import * as React from 'react'

import { CSSProperties } from 'react'
import { ComplexCard } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import { Carer, ConsentForm } from '@lmc/ts-common'

type LastReviewCardProps = {
  consentForm: ConsentForm
  lastReviewCarer: Carer
  style: CSSProperties
  translate: (id: string, variable?: any) => string
}

export const LastReviewCard = ({
  consentForm,
  lastReviewCarer,
  style,
  translate,
}: LastReviewCardProps): React.ReactElement => (
  <ComplexCard
    localisation={{
      title: translate('lastReview'),
      review: '',
    }}
    dateValue={dayjs(consentForm?.editedOn).format('DD-MM-YYYY • HH:mm')}
    style={style as CSSProperties}
    rightChildren=""
    // @ts-ignore
    user={
      lastReviewCarer
        ? {
            name: `${lastReviewCarer?.name?.first}${' '}${
              lastReviewCarer?.name.last
            }`,
            picture: lastReviewCarer?.picture,
          }
        : undefined
    }
  />
)

export default LastReviewCard
